import React, { memo } from 'react';
import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from 'src/components/ui/pagination';
import { DropdownMenuDemo } from 'src/components/Pagination/RowsPerPage';

export const PaginationComponent = memo(
  ({
    count = 0,
    currentPage,
    onPageChange,
    onRowsPerPageChange,
    rowsPerPageOptions,
    rowsPerPage,
    navigationLabel = false,
    disableRowsPerPage = false,
  }: {
    count?: number;
    currentPage: number;
    onPageChange: (page: any) => void;
    onRowsPerPageChange?: (value: any) => void;
    rowsPerPageOptions?: number[];
    rowsPerPage: number;
    navigationLabel?: boolean;
    disableRowsPerPage?: boolean;
  }) => {
    const totalPages = Math.ceil(count / rowsPerPage);

    const getPages = () => {
      const pages = [];

      if (totalPages <= 5) {
        for (let i = 1; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        if (currentPage <= 4) {
          for (let i = 1; i <= 5; i++) {
            pages.push(i);
          }
          pages.push('...');
          pages.push(totalPages);
        } else if (currentPage > totalPages - 4) {
          pages.push(1);
          pages.push('...');
          for (let i = totalPages - 4; i <= totalPages; i++) {
            pages.push(i);
          }
        } else {
          pages.push(1);
          pages.push('...');
          pages.push(currentPage - 1);
          pages.push(currentPage);
          pages.push(currentPage + 1);
          pages.push('...');
          pages.push(totalPages);
        }
      }

      return pages;
    };

    const pages = getPages();

    return (
      <div className="flex items-center">
        {!disableRowsPerPage && (
          <DropdownMenuDemo
            onRowsPerPageChange={onRowsPerPageChange}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={rowsPerPageOptions}
          />
        )}
        <Pagination>
          <PaginationContent>
            <PaginationItem>
              <PaginationPrevious
                navigationLabel={navigationLabel}
                onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
                disabled={currentPage === 1}
              />
            </PaginationItem>
            {pages.map((page, index) =>
              page === '...' ? (
                <PaginationItem key={`ellipsis_${index}`}>
                  <PaginationEllipsis />
                </PaginationItem>
              ) : (
                <PaginationItem key={`page_${page}`}>
                  <PaginationLink
                    isActive={page === currentPage}
                    onClick={() => onPageChange(page)}
                  >
                    {page}
                  </PaginationLink>
                </PaginationItem>
              ),
            )}
            <PaginationItem>
              <PaginationNext
                navigationLabel={navigationLabel}
                onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
                disabled={currentPage === totalPages}
              />
            </PaginationItem>
          </PaginationContent>
        </Pagination>
      </div>
    );
  },
);
